export const translations = {
  "da": {
    "frontend": {
      "view more": "Vis mere",
      "view less": "Vis mindre",
      "Select arrival date": "Vælg ankomstdato",
      "Select departure date": "Vælg afrejsedato",
      "nights": "nætter",
      "week": "uge",
      "weeks": "uger",
      "Arrival date": "Ankomstdato",
      "Departure date": "Afrejsedato",
      "calwidget-Select arrival date": "Vælg indflytningsdag",
      "calwidget-Select departure date": "Vælg afrejsedato",
      "calwidget-nights": "nætter",
      "calwidget-weeks": "uger",
      "calwidget-week": "uge",
      "calwidget-Select period": "Vælg periode",
      "calwidget-Select arrival": "Vælg ankomst"
    }
  },
  "de": {
    "frontend": {
      "view less": "Weniger anzeigen",
      "view more": "Mehr anzeigen",
      "Select arrival date": "Anreisedatum wählen",
      "Select departure date": "Abreisedatum wählen",
      "nights": "Nächte",
      "week": "Woche",
      "weeks": "Wochen",
      "Arrival date": "Anreisedatum",
      "Departure date": "Abreisedatum",
      "calwidget-Select arrival date": "Anreisedatum wählen",
      "calwidget-Select departure date": "Abreisedatum wählen",
      "calwidget-nights": "Nächte",
      "calwidget-weeks": "Wochen",
      "calwidget-week": "Woche",
      "calwidget-Select period": "Mietzeitraum wählen",
      "calwidget-Select arrival": "Anreise wählen"
    }
  }
}